/**
 * Author:hong.rong
 * Desc:重复pending request处理类
 * Date:2021-07-29
 */


import { AxiosStatic, AxiosRequestConfig } from "axios";

export default class PendingRequest {
  private pendingRequest = new Map();
  private axios: AxiosStatic;

  constructor(axios: AxiosStatic) {
    this.axios = axios
  }
  /**
   * 生成唯一key
   * @param config
   */
  generateReqKey(config: AxiosRequestConfig) {
    const { method, url, params, data } = config;
    return [method, url, JSON.stringify(params || {}), JSON.stringify(data || {})].join(
      "&"
    );
  }
  /**
   * 追加pending request
   * @param config
   */
  addPendingRequest(config: AxiosRequestConfig) {
    const requestKey = this.generateReqKey(config);
    const CancelToken = this.axios.CancelToken
    config.cancelToken =
      config.cancelToken ||
      new CancelToken((cancel) => {
        if (!this.pendingRequest.has(requestKey)) {
          this.pendingRequest.set(requestKey, cancel);
        }
      });
  }
  /**
   * 删除pending request
   * @param config
   */
  removePendingRequest(config: AxiosRequestConfig) {
    const requestKey = this.generateReqKey(config);
    if (this.pendingRequest.has(requestKey)) {
      const cancel = this.pendingRequest.get(requestKey);
      cancel(requestKey);
      this.pendingRequest.delete(requestKey);
    }
  }
}
